import React, { Component } from 'react';
import { Button, Theme, WithStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { MyPATDialog } from '../../common';

const styles = (theme: Theme) =>
    createStyles({
        buttonSection: {
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            padding: '18px 0',
            '& button': {
                minWidth: '5.88rem',
                height: '2.75rem',
                fontSize: '1rem',
                fontWeight: 500,
                lineHeight: '88%',
                padding: '0.94rem 1.69rem',
            }
        },
        declarationBody: {
            display: 'flex',
            flexDirection: 'column',
            gap: '30px',
            justifyContent: 'center',
            alignItems: 'center',
            '& img': {
                width: '100px',
            },
            '& .textContainer': {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '25px',
                fontSize: 16,
                fontWeight: 400,
                lineHeight: '21.82px',
                textAlign: "center",
                color: '#333',
            },
            '& .declarationTextContainer': {
                fontSize: 14,
                fontWeight: 400,
                lineHeight: '19.1px',
                textAlign: "left",
                color: '#333',
                display: 'flex',
                '& .declarationCheckbox': {
                    transform: "scale(1.5)",
                    marginRight: 10,
                    cursor: "pointer",
                },
            }
        }
    });

interface PublishContentDirectlyProps extends WithStyles<typeof styles> {
    classes: any;
    isModalOpen: boolean;
    fromLibrary: boolean;
    selectedQuestionsCount: number;
    onModalClose: Function;
    onDeclarationAccept: Function;
}

interface PublishContentDirectlyStates {
    isDeclarationAccepted: boolean;
}

class PublishContentDirectlyModal extends Component<PublishContentDirectlyProps, PublishContentDirectlyStates> {
    constructor(props: PublishContentDirectlyProps) {
        super(props);
        this.state = {
            isDeclarationAccepted: false
        };
    }

    onDeclarationCheckboxChange = (event: any) => {
        this.setState({
            isDeclarationAccepted: event.target.checked
        });
    }

    onSubmitDeclaration = () => {
        this.props.onDeclarationAccept();
        this.setState({ isDeclarationAccepted: false });
    }

    handleModalClose = () => {
        this.setState({ isDeclarationAccepted: false });
        this.props.onModalClose();
    }
    render() {
        const { classes, isModalOpen, onDeclarationAccept, fromLibrary, selectedQuestionsCount } = this.props;
        const { isDeclarationAccepted } = this.state;
        return (
            <MyPATDialog
                dialogHeading={
                    <span className={classes.dialogCustomHeading}>Declaration Required</span>
                }
                dialogOpen={isModalOpen}
                dialogHasActions={false}
                onDialogClose={this.handleModalClose}
                customButtonVariant="withoutBorderCloseIcon"
                isAlignCenter={true}
                stopParentScroll={false}
                otherDialogProps={{
                    fullWidth: true,
                    maxWidth: 'sm',
                    scroll: 'body'
                }}
                classes={{ root: classes.rejectReason }}
                customDialogActions={
                    <div className={classes.buttonSection}>
                        <Button
                            className={classes.primaryBtn}
                            autoFocus
                            variant="contained"
                            color="primary"
                            onClick={this.onSubmitDeclaration}
                            disabled={!isDeclarationAccepted}
                        >
                            I Accept
                        </Button>
                    </div>
                }
            >
                <div className={classes.declarationBody}>
                    <img src="/assets/svg/contentValidation/validation-sign.svg" alt="declaration" />
                    <div className='textContainer'>
                        {!!fromLibrary ?
                            <div>You are requesting to Publish the selected {selectedQuestionsCount} “In Review” question(s)</div> :
                            <div>You are requesting that this question be published directly.</div>
                        }
                        {!!fromLibrary ?
                            <div>
                                To publish these question within your centre for the purpose of using it in a test or assignment,
                                it is necessary for you to acknowledge and accept the declaration. New duplicate(s) of these questions
                                will be created which will undergo validation as defined, and once validated, they will be merged
                                with the original and the student's results will be recalculated.
                            </div> :
                            <div>
                                To publish this question within your centre for the purpose of using it in a test or assignment,
                                it is necessary for you to acknowledge and accept the declaration. A duplicate of this question will
                                be created which will undergo validation as defined, and once validated, it will be merged with the
                                original and the student's results will be recalculated.
                            </div>
                        }
                        <div className='declarationTextContainer'>
                            <div>
                                <input type='checkbox' className='declarationCheckbox' checked={isDeclarationAccepted} onChange={this.onDeclarationCheckboxChange.bind(this)}/>
                            </div>
                            <div>
                                I hereby confirm that the question being published adhere to our quality standards.
                                I accept full responsibility for its distribution and publication.
                                In the event of any reported issues with the question which can be used in tests or assignments,
                                I will take full accountability.
                            </div>
                        </div>
                    </div>
                </div>
            </MyPATDialog>
        )
    }
}

// @ts-ignore
export default (withStyles(styles)(PublishContentDirectlyModal));
